module.exports = __webpack_public_path__ + "img/300_SERF_2022_Flags.41c0fdf8.png";